import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // BrowserRouter 추가
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/TodayMood"> {/* 여기서만 BrowserRouter 사용 */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
